<mat-dialog-content>
  <div class="modalWrapper">
    <button class="cmn-close" (click)="onNoClick()"></button>

    <div class="headerClass">
      <h3>{{ data?.id ? 'Edit Profile' : 'Create New Profile' }}</h3>
    </div>

    <form>
      <div [formGroup]="documentForm">
        <div class="profileFlex-wrapper">
          <div class="profileWrapper">
            <div class="image-and-buttons">
              <div class="imageWrapper">
                <img
                  [src]="
                  removeProfilePic ? '../../../assets/images/dummy-profile-pic.png':
                  url || '../../../assets/images/dummy-profile-pic.png' "
                  alt=""
                />
              </div>
              <button>
                <label>
                  {{url ? "Change Image":"Add Image"}}
                  <input
                    #imgFileInput
                    type="file"
                    (change)="onFileSelected($event)"
                    accept=".jpeg, .jpg, .png,"
                  />
                </label>
              </button>
              <button
                *ngIf="url"
                (click)="onRemoveProfile()"
                class="remove-profile-btn"
              >
                <img src="assets/images/icons/icon-close.svg" alt="" />
              </button>
              <!-- <div
                class="remove-profile"
                *ngIf="url"
                (click)="onRemoveProfile()"
              >
                Remove Image
              </div> -->
            </div>
          </div>
          <div class="detailsWrapper">
            <div class="deailsHead">
              <label class="block-pointer">
                <span>Role</span>
                <mat-form-field>
                <mat-select formControlName="roleId">
                  <mat-option *ngFor="let role of rolesDropdown" [value]="role?.id">
                    {{ role?.name }}
                  </mat-option>
                </mat-select>
                  <mat-error
                    *ngIf="documentForm.get('roleId')?.hasError('required')"
                    >Role is required</mat-error
                  >
                </mat-form-field>
              </label>
              <label class="block-pointer">
                <span>Email Address</span>
                <mat-form-field>
                  <input
                    type="email"
                    formControlName="email"
                    matInput
                    placeholder="Email Address"
                  />
                  <mat-error
                    *ngIf="documentForm.get('email')?.hasError('required') &&documentForm.get('email')?.touched"
                    >Email is required</mat-error
                  >
                  <mat-error
                    *ngIf="documentForm.get('email')?.hasError('pattern') &&documentForm.get('email')?.touched"
                    >Invalid email</mat-error
                  >
                </mat-form-field>
              </label>
              <label class="block-pointer">
                <span>Name</span>
                <mat-form-field>
                  <input
                    type="text"
                    formControlName="displayName"
                    matInput
                    placeholder="Name"
                    maxlength="60"
                  />

                  <!-- Single error display for all validation errors -->
                  <mat-error *ngIf="documentForm.get('displayName')?.invalid && documentForm.get('displayName')?.touched">
                    {{ getDisplayNameErrors() }}
                  </mat-error>
                </mat-form-field>
              </label>
            </div>
            <div
              class="new-password"
              *ngIf="!data?.id || currRole === 'Super Admin'"
            >
              <label class="block-pointer">
                <span>New Password</span>
                <mat-form-field>
                  <input
                    [type]="newPasswordHidden ? 'password' : 'text'"
                    matInput
                    placeholder="New Password"
                    autocomplete="new-password"
                    formControlName="password"
                  />
                </mat-form-field>

                <mat-error
                  *ngIf="documentForm.get('password')?.hasError('required') &&documentForm.get('password')?.touched"
                  >Password is required</mat-error
                >
                <mat-error
                  *ngIf="documentForm.get('password')?.hasError('pattern') &&documentForm.get('password')?.touched"
                  >Password must be 6+ characters and include uppercase,
                  lowercase, number, special character and no spaces.</mat-error
                >
                <img
                  (click)="onHidePassword(2)"
                  [src]="
                      newPasswordHidden
                        ? '../../../assets/images/icons/icon-eye-closed.svg'
                        : '../../../assets/images/icons/icon-eye-open.svg'
                    "
                  alt=""
                />
              </label>

              <label class="block-pointer">
                <span>Confirm Password</span>
                <mat-form-field>
                  <input
                    [type]="confirmPasswordHidden ? 'password' : 'text'"
                    matInput
                    placeholder="Confirm Password"
                    autocomplete="confirm-password"
                    formControlName="confirmPassword"
                  />
                </mat-form-field>

                <mat-error
                  *ngIf="documentForm.get('confirmPassword')?.hasError('required') &&documentForm.get('confirmPassword')?.touched"
                  >Confirm Password is required</mat-error
                >
                <mat-error
                  *ngIf="documentForm.get('confirmPassword')?.hasError('pattern') &&documentForm.get('confirmPassword')?.touched"
                  >Invalid Confirm Password</mat-error
                >

                <img
                  (click)="onHidePassword(3)"
                  [src]="
                      confirmPasswordHidden
                        ? '../../../assets/images/icons/icon-eye-closed.svg'
                        : '../../../assets/images/icons/icon-eye-open.svg'
                    "
                  alt=""
                />
              </label>
            </div>
            <div class="btn-wrapper">
              <button class="cmn-cancel-btn" (click)="onCancel()">
                Cancel
              </button>
              <button class="cmn-next-btn" (click)="onSave()">
                {{ data?.id ? 'Update' : 'Save' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="password-manager" *ngIf="changePassword">

      </div> -->
    </form>
  </div>
</mat-dialog-content>

<app-fullscreen-loader
  [visible]="uploading || loading"
  [message]="uploading ? 'Uploading file, please wait...' : 'Saving, Please wait' "
></app-fullscreen-loader>
